import {SubsequentDeliveriesUpdate} from '../../../core/models/subsequent-deliveries/subsequent.deliveries.update';

export class ConfirmationDialogModel {
    constructor(public title: string, public message: string, public delivery: any) {
    }
}
